<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <DriverPhotosSearchBoxForDriver
          @search="search"
          :query="query"
        ></DriverPhotosSearchBoxForDriver>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <DriverPhotosListForDriver
            ref="driverPhotosList"
            v-if="!loading"
            style="width: 100%"
            @refresh="refresh"
            :driverPhotos="driverPhotos"
            :pagination="pagination"
            :query="query"
          ></DriverPhotosListForDriver>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverPhotosListForDriver from "@/components/driver/DriverPhotosListForDriver.vue";
import DriverPhotosSearchBoxForDriver from "@/components/driver/DriverPhotosSearchBoxForDriver.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "drivers_photos_for_driver",
  components: {
    SimpleCard,
    DriverPhotosListForDriver,
    DriverPhotosSearchBoxForDriver,
  },
  data: function () {
    return {
      offset: 0,
      count: 20,
      query: {
        flagged: false,
      },
      numPages: 0,
      driverPhotos: [],
    };
  },
  methods: {
    search: function () {
      console.log("Search");
      this.$refs.driverPhotosList.clearAndRefresh();
    },
    refresh: function () {
      this.$refs.driverPhotosList.refresh();
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
